export default function getResource(label, vars = []) {
    const resources = {
        title: 'Appliquer des récompenses Rouge',
        apply: 'Appliquer',
        applied: 'Appliqué',
        remove: 'Supprimer',
        rougeRewardsSubText: `${vars[0]} $ en récompenses Rouge`,
        rougeRewardsExpirationMessage: `Exp. ${vars[0]}`,
        done: 'Terminé',
        switchToUS: 'Rouge Reward can only be used in the country where the reward was redeemed. Please switch to our US shopping experience to use this reward.',
        switchToCA: 'Rouge Reward can only be used in the country where the reward was redeemed. Please switch to our Canada shopping experience to use this reward.'
    };

    return resources[label];
}
